<div #origin (click)="isOpen = true" [style]="style">
  <ng-content select="[trigger]" />
</div>

<ng-template
  cdk-connected-overlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="hasBackdrop"
  [cdkConnectedOverlayBackdropClass]="backdropClass"
  [cdkConnectedOverlayWidth]="width"
  (attach)="attached.emit()"
  (detach)="detached.emit()"
  (backdropClick)="isOpen = false">
  <ng-content />
</ng-template>
